import { render, staticRenderFns } from "./ProjectVideoListDialog.vue?vue&type=template&id=083257c8&scoped=true&"
import script from "./ProjectVideoListDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectVideoListDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProjectVideoListDialog.vue?vue&type=style&index=0&id=083257c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083257c8",
  null
  
)

export default component.exports